// import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import style from './time-down.css';

class TimeDown extends React.Component {
    constructor (props) {
        super(props);
        
        bindAll(this, [
            'onAnimationEnd'
        ]);

        this.state = {
            timedown: true
        };
    }
    componentDidMount () {
        this.createTimedown();
    }
    componentWillUnmount () {
        this.destoryTimedown();
    }
    onAnimationEnd () {
        const {onEnd} = this.props;
        onEnd();
    }
    createTimedown () {
        if (!this.timedownRef) {
            this.timedownRef = document.createElement('div');
            this.timedownRef.className = style.timedownContainer;
            const timedown = document.createElement('div');
            timedown.className = style.timedown;
            const num = document.createElement('div');
            num.className = style.num;
            num.innerHTML = '3 2 1 0';
            num.onanimationend = this.onAnimationEnd;
            timedown.appendChild(num);
            this.timedownRef.appendChild(timedown);
            document.body.appendChild(this.timedownRef);
        }
    }
    destoryTimedown () {
        if (this.timedownRef) {
            document.body.removeChild(this.timedownRef);
            this.timedownRef = null;
        }
    }

    render () {
        return (<div />);
        // <div className={style.timedownContainer}>
        //     <div className={style.timedown}>
        //         <div
        //             className={style.num}
        //             // ref="numRecord"
        //             onAnimationEnd={this.onAnimationEnd}
        //         >3 2 1 0</div>
        //     </div>
        // </div>
    }
}
TimeDown.propTypes = {
    
};

export default TimeDown;
